import { render, staticRenderFns } from "./NewCollectPaymentModal.vue?vue&type=template&id=25621277"
import script from "./NewCollectPaymentModal.vue?vue&type=script&lang=js"
export * from "./NewCollectPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports